import {
  PlatePage_CulturePlate,
  PlatePage_ObservationHistory,
} from '~/api/backend/pages/platePageAPI'
import Tabs from '~/components/Tabs'
import ObservationMetadataSidebar from '~/pages/plate/PlateObservationMetadataSidebar'
import { PlateCellConcentrationGraphSideBar } from './PlateCellConcentrationsGraph'

export interface PlateConcentrationTabbedSidebarProps {
  plate: PlatePage_CulturePlate
  highlightedWell?: string
  observation?: PlatePage_ObservationHistory
}

export default function PlateConcentrationTabbedSidebar({
  plate,
  highlightedWell,
  observation,
}: PlateConcentrationTabbedSidebarProps) {
  const tabs = [
    {
      key: 'graph',
      title: 'Graph',
      panel: (
        <PlateCellConcentrationGraphSideBar
          plate={plate}
          highlightedWell={highlightedWell}
        />
      ),
    },
    {
      key: 'metadata',
      title: 'Metadata',
      panel: (
        <div className='space-y-4'>
          {observation && (
            <ObservationMetadataSidebar plate={plate} observation={observation} />
          )}
        </div>
      ),
    },
  ]

  return (
    <div>
      <Tabs tabs={tabs} initialTab='graph' />
    </div>
  )
}
